<template>
<w-sliding-popup
  popupClass="topologymap-event-popup"
  type="full"
  :title="title"
  @close="close"
  :visible="true"
  ref="slidingPopup">
    <div slot="content">
    <w-tool-tabs v-model="activeTabName" @tab-click="tabClick">
      <el-tab-pane :label="tabs['event-status'].label" :name="tabs['event-status'].name" class="h100 w100">
        <w-topologymap-event-common-table
          ref="eventStatusRef"
          :active="tabs['event-status'].active"
          eventType="status"
          class="topologymap_event_common_table"
          ></w-topologymap-event-common-table>
      </el-tab-pane>
      <el-tab-pane :label="tabs['event-hist'].label" :name="tabs['event-hist'].name" class="h100 w100">
        <el-row class="mr-b20">
          <el-row v-show="!isOpenStatsBox">
            <w-topologymap-eventlevel-count-box ref="eventlevelCountBox" :active="tabs['event-hist'].active" @click-open-stats-box-button="clickOpenStatsBoxButton" />
          </el-row>
          <el-row v-show="isOpenStatsBox" :gutter="10" height:250px>
            <el-col :span="6">
              <w-topologymap-event-hist-pie-chart ref="eventlevelPieChart" title="이벤트 등급 건수" :active="tabs['event-hist'].active" chart-type="eventlevel"
              :current-filter-count="currentFilterCount" @set-event-hist-filter="setEventHistFilter"/>
            </el-col>
            <el-col :span="6">
              <w-topologymap-event-hist-pie-chart ref="objDefinePieChart" title="관리구분 건수" :active="tabs['event-hist'].active" chart-type="objDefine"
              :current-filter-count="currentFilterCount" @set-event-hist-filter="setEventHistFilter"/>
            </el-col>
            <el-col :span="12">
              <w-topologymap-event-top-box ref="eventTopBox" :active="tabs['event-hist'].active"  @click-open-stats-box-button="clickOpenStatsBoxButton"
                :current-filter-count="currentFilterCount" @set-event-hist-filter="setEventHistFilter" :filter-list="filterList" class="topologymap_event_top_box"/>
            </el-col>
          </el-row>
        </el-row>
        <el-row class="mr-b20">
          <el-row class="mr-b10">
              <w-event-hist-filter-box ref="eventHistFilterBox" @delete-event-hist-filter="deleteEventHistFilter" @set-event-hist-filter="setEventHistFilter"
              @change-filter-list="changeFilterList"/>
          </el-row>
          <el-row  class="mr-b10">
            <w-topologymap-event-hist-stacked-column-chart
              ref="eventHistStackedColumnChart"
              style="height: 200px;"
              :active="tabs['event-hist'].active" :filter-params="filterParams"></w-topologymap-event-hist-stacked-column-chart>
          </el-row>
          <w-topologymap-event-common-table
          ref="eventCommonTable"
          :active="tabs['event-hist'].active"
          eventType="hist" :filter-params="filterParams"></w-topologymap-event-common-table>
        </el-row>
      </el-tab-pane>
      <el-tab-pane :label="tabs['trouble-ticket'].label" :name="tabs['trouble-ticket'].name" class="h100 w100">
        <w-topologymap-trouble-ticket ref="troubleTicket" :active="tabs['trouble-ticket'].active"/>
      </el-tab-pane>
      <el-tab-pane :label="tabs['event-predict'].label" :name="tabs['event-predict'].name" class="h100 w100">
        <w-topologymap-event-predict ref="eventPredict" :active="tabs['event-predict'].active"/>
      </el-tab-pane>

      <el-row slot="tool" type="flex" justify="end">
        <div class="vetical-center-box" v-if="activeTabName == 'event-status' || activeTabName == 'event-hist'">
          <w-smart-analyzer-button class="mr-r4" style="display:inline-block;" :activeTab="activeTabName"></w-smart-analyzer-button>
          <w-event-ticket-add-button class="mr-r4" style="display:inline-block;" :active-tab="activeTabName" @load-data="loadData"></w-event-ticket-add-button>
        </div>
        <w-kedb-list-popup-button />
      </el-row>
    </w-tool-tabs>
    <w-scroll-top-button :visible="enableScollTop" @move-scroll-top="moveScrollTop"/>
    <w-event-smart-analyzer-popup />
    </div>
</w-sliding-popup>
</template>

<script>
import ScrollbarMixin from '@/mixins/scrollbar';
import { isEmpty, isNil } from 'lodash';

import WEventSmartAnalyzerPopup from '@/components/popup/EventSmartAnalyzerPopup';
import WSmartAnalyzerButton from '@/views/event/components/SmartAnalyzerButton';
import WEventTicketAddButton from '@/views/event/components/EventTicketAddButton';
import WKedbListPopupButton from '@/views/event/kedb/components/button/KedbListPopupButton';

import WTopologymapEventCommonTable from '@/views/topologymap/components/event/TopologymapEventCommonTable';
import WTopologymapEventHistStackedColumnChart from '@/views/topologymap/components/event/TopologymapEventHistStackedColumnChart';
import WTopologymapTroubleTicket from '@/views/topologymap/components/event/TopologymapTroubleTicket';
import WTopologymapEventPredict from '@/views/topologymap/components/event/TopologymapEventPredict';

import WTopologymapEventTopBox from '@/views/topologymap/components/event/TopologymapEventTopBox';
import WTopologymapEventHistPieChart from '@/views/topologymap/components/event/TopologymapEventHistPieChart';
import WEventHistFilterBox from '@/views/event/event-hist/components/EventHistFilterBox';
import WTopologymapEventlevelCountBox from '@/views/topologymap/components/event/TopologymapEventlevelCountBox';

export default {
  name: 'WTopologymapEventPopup',
  mixins: [ScrollbarMixin],
  components: {
    WEventSmartAnalyzerPopup,
    WSmartAnalyzerButton,
    WEventTicketAddButton,
    WKedbListPopupButton,

    WTopologymapEventCommonTable,
    WTopologymapEventHistStackedColumnChart,
    WTopologymapTroubleTicket,
    WTopologymapEventPredict,

    WTopologymapEventlevelCountBox,
    WTopologymapEventTopBox,
    WTopologymapEventHistPieChart,
    WEventHistFilterBox,
  },
  data() {
    return {
      isOpenStatsBox: true,
      currentFilterCount: 0,
      filterList: [],
      filterParams: {},
      activeTabName: 'event-status',
      tabs: {
        'event-status': {
          name: 'event-status',
          label: '이벤트 현황',
          active: false,
        },
        'event-hist': {
          name: 'event-hist',
          label: '이벤트 이력',
          active: false,
        },
        'trouble-ticket': {
          name: 'trouble-ticket',
          label: '장애 티켓',
          active: false,
        },
        'event-predict': {
          name: 'event-predict',
          label: '사전 예측 이벤트',
          active: false,
        },
      },
    };
  },
  computed: {
    title() {
      const breadCrumb = this.$store.getters.getBreadcrumb;
      let mapName = isEmpty(breadCrumb) ? '' : breadCrumb[breadCrumb.length - 1].mapName;
      mapName = mapName.length > 40 ? `${mapName.substring(0, 40)}...` : mapName;
      return `[${mapName}] 이벤트 정보`;
    },
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    loadData() {
      this.$nextTick(() => {
        if (this.activeTabName === 'event-status') {
          this.$refs.eventStatusRef.loadData();
        } else if (this.activeTabName === 'event-hist') {
          this.$refs.eventCommonTable.loadData();
        }
      });
    },
    open() {
      this.activeTabName = 'event-status';
      this.tabs['event-status'].active = true;
      this.$refs.slidingPopup.visible = true;
    },
    close() {
      this.$refs.slidingPopup.visible = false;
      Object.keys(this.tabs).forEach((key) => {
        this.tabs[key].active = false;
      });
      this.clear();
    },
    tabClick(clickedTab) {
      const { name } = clickedTab;
      Object.keys(this.tabs).forEach((key) => {
        if (name === key) {
          this.tabs[key].active = true;
        } else {
          this.tabs[key].active = false;
        }
      });
    },
    clickOpenStatsBoxButton() {
      this.isOpenStatsBox = !this.isOpenStatsBox;
    },
    setEventHistFilter(filter) {
      this.$refs.eventHistFilterBox.setEventHistFilter(filter);
    },
    deleteEventHistFilter(filter) {
      if (isNil(filter)) {
        this.$refs.eventlevelPieChart.deleteEventHistFilter(filter);
        this.$refs.objDefinePieChart.deleteEventHistFilter(filter);
        this.$refs.eventTopBox.deleteEventHistFilter(filter);
        return;
      }
      if (filter.type === 'eventlevel') {
        this.$refs.eventlevelPieChart.deleteEventHistFilter(filter);
      } else if (filter.type === 'objDefine') {
        this.$refs.objDefinePieChart.deleteEventHistFilter(filter);
      } else if (filter.type === 'obj' || filter.type === 'rsc') {
        this.$refs.eventTopBox.deleteEventHistFilter(filter);
      }
    },
    changeFilterList(filterList) {
      const filterParams = {
        eventlevelIds: [],
        objDefineIds: [],
        objIds: [],
        rscMixKeys: [],
      };
      filterList.forEach((item) => {
        if (item.type === 'eventlevel') {
          filterParams.eventlevelIds.push(item.eventlevelId);
        } else if (item.type === 'objDefine') {
          filterParams.objDefineIds.push(item.objDefineId);
        } else if (item.type === 'obj') {
          filterParams.objIds.push(item.objId);
        } else if (item.type === 'rsc') {
          filterParams.rscMixKeys.push(item.rscMixKey);
        }
      });
      this.filterParams = filterParams;
      this.filterList = filterList;
      this.currentFilterCount = filterList.length;
    },
    clear() {
      Object.assign(this.$data, this.$options.data());
    },
  },
};
</script>

<style lang="scss">
.topologymap-event-popup {
  .el-tabs__content {
    width: 100%;
  }
  .el-tabs__header > .el-tabs__nav-wrap {
    padding-left: 20px;
  }
}
.topologymap_event_top_box {
  .el-input__inner {
    padding-right: 0px;
  }
}
.topologymap_event_common_table  {
  .el-button {
    vertical-align: middle;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/popup/TopologymapEventPopup.vue